import { RouterProvider } from 'react-router-dom';
import getEstimatorRouter from './estimatorRouter';
import ErrorBoundary from './individual/components/common/ErrorBoundary';

function EstimatorApp() {
  return (
    <ErrorBoundary>
      <RouterProvider
        router={getEstimatorRouter()}
        future={{ v7_startTransition: true }}
      />
    </ErrorBoundary>
  );
}

export default EstimatorApp;
